import React from "react";
import { getFeedback } from "../../../services/moodle/courses";
import { useAuth } from "../../../contexts/AuthContext";
import { useTheme } from "../../../contexts/ThemeContext";
//f
export const ProgressRowItemDetail = ({ detail, includeFeedback, index }) => {
  const [feedback, setFeedback] = React.useState("-");
  const [generalFeedback, setGeneralFeedback] = React.useState("-");

  const theme = useTheme();
  const { user } = useAuth();

  const isEven = index % 2 === 1;

  React.useEffect(() => {
    if (detail.feedback && detail.feedback !== "") {
      setFeedback(detail.feedback);
    }

    if (
      detail.itemmodule === "quiz" &&
      detail.graderaw !== null &&
      detail.graderaw !== undefined &&
      detail.iteminstance
    ) {
      const args = {
        token: user.token,
        quizid: detail.iteminstance,
        grade: detail.graderaw,
      };
      getFeedback(args)
        .then((res) => {
          if (res?.feedbacktext) {
            setGeneralFeedback(res.feedbacktext);
          }
        })
        .catch((err) => {
          console.error("Error fetching quiz feedback:", err);
        });
    }
    //eslint-disable-next-line
  }, [detail]);

  const rowBg = theme.mode === "dark"
    ? (isEven ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.02)")
    : (isEven ? "#F5F5F5" : "#FFFFFF");

  const titleColor = theme.mode === "dark" ? "#E0E0E0" : "#1A1A1A";
  const textColor = theme.mode === "dark" ? "#B0B0B0" : "#3D3D3D";

  return (
    <>
      <tr style={{ backgroundColor: rowBg }}>
        <th
          className="p-[16px] font-lato font-medium text-[14px] border-none"
          style={{ color: titleColor }}
        >
          <p
            className="font-lato font-medium text-[14px] break-words whitespace-normal leading-snug"
            style={{ color: titleColor }}
          >
            {detail.itemname}
          </p>
        </th>
        <td
          className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap"
          style={{ color: textColor }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
            }}
            dangerouslySetInnerHTML={{
              __html:
                detail.gradeformatted && detail.gradeformatted.split("(")[0],
            }}
          />
        </td>
        {includeFeedback && (
          <>
            <td
              className="p-[16px] font-lato text-[14px] border-none"
              style={{ color: textColor }}
              dangerouslySetInnerHTML={{
                __html: feedback,
              }}
            ></td>
            <td
              className="p-[16px] font-lato text-[14px] border-none"
              style={{ color: textColor }}
              dangerouslySetInnerHTML={{
                __html: generalFeedback,
              }}
            ></td>
          </>
        )}
      </tr>
    </>
  );
};
